import React, { HTMLAttributes, ReactNode } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface FlexStackProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  spacing?: number;
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
}

const FlexStack = React.forwardRef<HTMLDivElement, FlexStackProps>(
  ({ children, spacing = 8, ...props }: FlexStackProps, forwardedRef) => {
    return (
      <Container ref={forwardedRef} spacing={spacing} {...props}>
        {children}
      </Container>
    );
  },
);

const Container = styled.div<Pick<FlexStackProps, 'spacing' | 'direction'>>`
  ${({ spacing, direction }) => css`
    display: flex;
    flex-direction: ${direction || 'column'};
    gap: ${spacing}px;
  `}
`;

export default FlexStack;
